import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod";

export const getLocationsWithFulfillsFor = {
  name: "getLocationsWithFulfillsFor" as const,
  input: z.object({}),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
